import React, { useMemo } from "react";
import CaptionTable from "components/general/table/CaptionTable";
import MirsTable from "components/general/table/Table";
import Label from "components/general/Label"
import Status from "components/presentation/Status";
import Esl from "components/common/Esl";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import { isStartListStatus, isFinishedStatus, isLiveStatus } from "helpers/status";
import { useViewport } from 'components/general/useViewPort'
import WlfExtendedResul from "components/sports/wlf/views/WlfExtendedResul";
import { getLongEventRSC } from 'helpers/rsc';
import { RscFromStore } from "helpers/utils";

import WlfTableColumns from "components/sports/wlf/events/Colums.js";
import WlfTableColumnsSMStartList from "components/sports/wlf/events/ColumnsSMStartList";
import { WlfTableColumnsSMLiveSnacht, WlfTableColumnsSMLiveClean } from "components/sports/wlf/events/ColumnsSMLive";
import WlfTableColumnsSMFinished from "components/sports/wlf/events/ColumnsSMFinished";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const WlfResult = ({ data }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  const { breakPoint } = useViewport();
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  const resultStatus = data?.results?.status?.code;
  const isStartList = isStartListStatus(resultStatus)
  const isLive = isLiveStatus(resultStatus)
  const isFinished = isFinishedStatus(resultStatus)
  let rsc = RscFromStore()

  let hideColumns = [];
  if (isStartList) { hideColumns = ['Rank'] }
  if (isFinished) { hideColumns = ['Bib'] }

  let info = data?.results?.extendedInfos;
  let infoCurrentLast = info?.find(row => row.ei_code === 'LAST_COMP');
  let posLast = infoCurrentLast?.ei_pos;
  let infoCurrentCurrent = info?.find(row => row.ei_code === 'CURRENT');
  let posCurrent = infoCurrentCurrent?.ei_pos;

  let isClean = false;
  if (posLast === "11" || posLast === "12" || posLast === "13" || posCurrent === "11" || posCurrent === "12" || posCurrent === "13") {
    isClean = true;
  }
  const resultsItems = data?.results?.items
  const hasRecordTotal = resultsItems?.some(item => item?.recordIndicators?.find(row => row.ri_code === getLongEventRSC(rsc)));
  const hasRecordSnatch = resultsItems?.some(item => item?.extendedResults?.find(row => (row.er_code === 'SNATCH' && row.er_pos === 'TOTAL') && row.extensions?.find(ext => ext.ere_code === 'RECORD')));
  const hasRecordClean = resultsItems?.some(item => item?.extendedResults?.find(row => (row.er_code === 'CLEAN' && row.er_pos === 'TOTAL') && row.extensions?.find(ext => ext.ere_code === 'RECORD')));


  let ColumsShow = WlfTableColumns(hasRecordTotal, hasRecordSnatch, hasRecordClean);

  if (isMobile) {
    if (isStartList) {
      ColumsShow = WlfTableColumnsSMStartList(hasRecordTotal, hasRecordSnatch, hasRecordClean);
    } else if (isLive) {
      if (isClean) {
        ColumsShow = WlfTableColumnsSMLiveClean(hasRecordTotal, hasRecordSnatch, hasRecordClean);
      } else {
        ColumsShow = WlfTableColumnsSMLiveSnacht(hasRecordTotal, hasRecordSnatch, hasRecordClean);
      }
    } else if (isFinished) {
      ColumsShow = WlfTableColumnsSMFinished(hasRecordTotal, hasRecordSnatch, hasRecordClean);
    }
  }



  //  const tableColumns = useMemo(() => WlfTableColumns(), []);
  const tableColumns = useMemo(() => ColumsShow, [isMobile, isClean, resultStatus]);

  const captionTable = <CaptionTable
    leftCol={<>{isStartList ? <Label data="HeaderStartList" /> : <Label data="HeaderResult" />}</>}
    rightCol={<Status typeToPrint={'result'} scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={data?.results?.status?.code} />}
  />

  // Create a function that will render our row sub components
  const renderRowSubComponent = React.useCallback(({ row }) => {
    let ExpandedSM = isFinished ? <WlfExtendedResul data={row?.original} /> : <Esl data={row?.original?.extCompetitor} />
    return (
      <LoaderSubComponent component={ExpandedSM} />
    )
  }, [resultStatus]);

  let playersCurrents = data?.results?.extendedInfos?.find(row => row.ei_code === 'CURRENT');
  let current = playersCurrents?.ei_value;

  const showAll = resultsItems?.some(item => item?.extCompetitor);
  if ((!showAll && !isFinished) || (!isMobile && isFinished)) hideColumns.push('Expander')

  return (
    <>
      {resultsItems &&
        < MirsTable
          className='table-result'
          sortable={!isMobile}
          getRowProps={row => ({
            className: current === row?.original?.participant?.code ? 'currentIndicator' : '',
          })}
          data={resultsItems}
          columns={tableColumns}
          id={`mirs-table-race-facts-${mirs_rsc}`}
          caption={captionTable}
          hiddenColumns={hideColumns}
          renderRowSubComponent={renderRowSubComponent}
        />
      }
    </>
  )
};

export default WlfResult;



